
import "./winners.css"


const weekArray = ["првог", "другог", "трећег", "четвртог", "петог", "шестог"]

const phaseObject = {
    'phase1': 'првог пресека 13.04.2026:',
    'phase2': 'другог пресека 20.04.2026:',
    'phase3': 'трећег пресека 27.04.2026:',
    'phase4': 'четвртог пресека 04.05.2026:',
    'phase5': 'петог пресека 11.05.2026:',
    'phase6': 'шестог пресека 18.05.2026:',
}
const Winners = ({winners}) => {

    return (
        <div className="content questionsAnswers rulesPage winnersPage">
            <div className="titleMobileDisplay">
                ДОБИТНИЦИ
            </div>

            <div className="qa">
                {Object.entries(winners)
                    .sort((a, b) => b[0].localeCompare(a[0], 'en', { numeric: true }))
                    .map(([key, week], i) => (
                        <div className="item" key={i}>
                            <div className="weekTitle">Добитни кодови {phaseObject[key]} </div>
                            {week.map((prize, prizeIndex) => (
                                <div className="prizeInfo" key={prizeIndex}>
                                    {prize.codes.length > 0 && (
                                        <div className="prizeTitle">
                                            {prizeIndex === 0 && "Сет за роштиљ"}
                                            {prizeIndex === 1 && "Кухињски фрижидер"}
                                            {prizeIndex === 2 && "Ваучер од 2000 евра за опремање кухиње"}
                                            {prizeIndex === 3 && "Аутомобил ШКОДА ОКТАВИЈА"}
                                        </div>
                                    )}

                                    <div className="codes">
                                        {prize.codes.map((code) => (
                                            <span key={code}>{code}, {" "}</span>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
            </div>

        </div>
    )
}

export default Winners